import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Table, Modal } from 'antd';
import GetColumns from './FileTableColumns';
import TableFooter from './TableFooter';
import State from '../../State';
import Events from '../../Events';
import ImageCompareController from '../image-compare/ImageCompareController';

const FileTable = props => {
	const { emptyText, className } = props;
	const [fileForCompare, setFileForCompare] = useState(null);
	const [files, setFiles] = useState([...State.files]);
	const pageSize = useRef(8);
	function onFilesChanged() {
		setFiles([...State.files]);
	}
	function onFilesDeleted() {
		setFiles([...State.files]);
	}
	// page size
	const isMobile = window.innerWidth < 576;
	const availableHeight = window.innerHeight - (isMobile ? 256 : 288);
	pageSize.current = availableHeight / 55;

	function handleCompareButtonClick(file) {
		file = {
			url: 'https://imagecompressor.io/images/c/slider2-BIbhgvfs.jpg',
			originalFilePath: 'https://imagecompressor.io/images/slider2.jpg',
			width: 1048,
			height: 528,
			displayWidth: 2000,
			displayHeight: 800,
			sizeFormatted: '298.99 KB',
			compressedSizeFormatted: '128.99 KB'
		};
		setFileForCompare(file);
	}
	function onClose() {
		setFileForCompare(null);
	}
	useEffect(() => {
		Events.OnFileAdded(onFilesChanged);
		Events.OnFileRemoved(onFilesChanged);
		Events.OnFilesDeleted(onFilesDeleted);
		return () => {
			Events.OnFileAdded(onFilesChanged, true);
			Events.OnFileRemoved(onFilesChanged, true);
			Events.OnFilesDeleted(onFilesDeleted, true);
		};
	}, []);
	return (
		<Fragment>
			<Table
				className={className}
				dataSource={files}
				columns={GetColumns(handleCompareButtonClick)}
				size="small"
				pagination={{ pageSize: pageSize.current,
					simple: true,
					showTotal: total => { return `${total} images`; } }}
				locale={{ emptyText }}
				showHeader={false}
				bordered
				footer={() => { return <TableFooter files={files} />; }}
			/>
			<Modal
				visible={fileForCompare !== null}
				onCancel={onClose}
				centered
				footer={null}
				destroyOnClose
				mask={false}
				wrapClassName="ic-modal"
			>
				<ImageCompareController file={fileForCompare} />
			</Modal>
		</Fragment>
	);
};

export default FileTable;



// WEBPACK FOOTER //
// ./src/components/file-table/FileTable.js